import { createSelector } from 'reselect';

import { idX } from '../helpers';

export const categories = state => state.categoriesList.categories;
export const selectedCategory = state => state.categoriesList.selectedCategory;

export const categoriesSelector = createSelector(categories, idX);
export const selectedCategorySelector = createSelector(selectedCategory, idX);
